import { initDatadog } from './utils/datadog'
import * as Sentry from "@sentry/react"
import React, { useEffect } from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import { createRoutesFromChildren, matchRoutes } from 'react-router'
import ReactDOM from 'react-dom/client'
import 'react-datepicker/dist/react-datepicker.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from './utils/ThemeColorContext'
import { AuthProvider } from './utils/AuthContext'
import { Provider } from 'react-redux'
import Store from './redux'
import { LaunchDarklyWrapper } from './utils/LaunchDarkly'

initDatadog()

Sentry.init({
  dsn: "https://f24ba1f9e19efe51efb6733d2a24535a@o273284.ingest.us.sentry.io/4507377817681920",
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    // Sentry.browserTracingIntegration(),
    // Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <AuthProvider>
    <ThemeProvider>
      <Provider store={Store}>
        <LaunchDarklyWrapper>
          <App />
        </LaunchDarklyWrapper>
      </Provider>
    </ThemeProvider>
  </AuthProvider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
